import { useState, useEffect, useRef } from "react";
import { useTheme } from "../components/ThemeProvider";
import AppLayout from "../components/layout/AppLayout";

const API = import.meta.env.VITE_API_URL || "https://vitalcasa-crm-production.up.railway.app/api";

const TIPOS = {
  lead_creado:        { icon: "👤", color: "#3b82f6", label: "Lead creado" },
  ana_primer_contacto:{ icon: "🤖", color: "#8b5cf6", label: "Ana contacta" },
  ana_busqueda:       { icon: "🔎", color: "#14b8a6", label: "Búsqueda Ana" },
  interes_cliente:   { icon: "🎯", color: "#10b981", label: "Interés cliente" },
  cliente_responde:   { icon: "💬", color: "#6b7280", label: "Cliente responde" },
  intencion_detectada:{ icon: "🧠", color: "#f59e0b", label: "Intención detectada" },
  conversion_cliente: { icon: "⭐", color: "#22c55e", label: "Conversión a cliente" },
  agente_asignado:    { icon: "👩‍💼", color: "#06b6d4", label: "Agente asignado" },
  tarea_principal:    { icon: "📌", color: "#f97316", label: "Tarea principal" },
  cambio_etapa:       { icon: "📊", color: "#a78bfa", label: "Cambio etapa" },
  ana_wa_desconectada:{ icon: "📵", color: "#ef4444", label: "Ana WA caída" },
  ana_wa_reconectada: { icon: "✅", color: "#22c55e", label: "Ana WA OK" },
  ana_wa_alerta_ops:  { icon: "📲", color: "#f59e0b", label: "Alerta ops Ana" },
  error:              { icon: "❌", color: "#ef4444", label: "Error" },
};

const NIVELES = {
  info:    { bg: "rgba(59,130,246,0.08)",  border: "rgba(59,130,246,0.2)"  },
  success: { bg: "rgba(34,197,94,0.08)",   border: "rgba(34,197,94,0.2)"   },
  warning: { bg: "rgba(245,158,11,0.08)",  border: "rgba(245,158,11,0.2)"  },
  error:   { bg: "rgba(239,68,68,0.08)",   border: "rgba(239,68,68,0.2)"   },
};

function EventoItem({ e, isDark, border, textPrimary, textMuted }) {
  const [abierto, setAbierto] = useState(false);
  const tipo = TIPOS[e.tipo] || { icon: "📋", color: "#6b7280", label: e.tipo };
  const nivel = NIVELES[e.nivel] || NIVELES.info;
  const hora = new Date(e.created_at).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  const fecha = new Date(e.created_at).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit" });
  const searchDecision = e.metadata?.searchDecision || null;
  const criterios = e.metadata?.criterios || null;
  const expansion = searchDecision?.expansion || null;
  const expansionResolution = e.metadata?.expansionResolution || null;
  const interestEvaluation = e.metadata?.evaluation || null;

  return (
    <div onClick={() => setAbierto(p => !p)} style={{
      padding: "10px 16px", marginBottom: 4, borderRadius: 8, cursor: "pointer",
      background: nivel.bg, border: `1px solid ${nivel.border}`,
      transition: "all 0.15s",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {/* Hora */}
        <span style={{ fontSize: 10, color: textMuted, fontFamily: "monospace", flexShrink: 0, minWidth: 70 }}>
          {fecha} {hora}
        </span>
        {/* Icono tipo */}
        <span style={{ fontSize: 16, flexShrink: 0 }}>{tipo.icon}</span>
        {/* Título */}
        <span style={{ fontSize: 13, fontWeight: 600, color: textPrimary, flex: 1 }}>
          {e.titulo}
        </span>
        {/* Badge tipo */}
        <span style={{
          fontSize: 10, padding: "1px 7px", borderRadius: 20, flexShrink: 0,
          background: `${tipo.color}20`, color: tipo.color, border: `1px solid ${tipo.color}40`,
          fontWeight: 600,
        }}>
          {tipo.label}
        </span>
        {/* Expandir */}
        {(e.detalle || e.metadata) && (
          <span style={{ fontSize: 10, color: textMuted }}>{abierto ? "▲" : "▼"}</span>
        )}
      </div>

      {/* Detalle expandido */}
      {abierto && (
        <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${border}` }}>
          {e.detalle && (
            <div style={{ fontSize: 12, color: textMuted, marginBottom: 6, lineHeight: 1.5 }}>
              {e.detalle}
            </div>
          )}
          {searchDecision && (
            <div style={{ fontSize: 11, color: textMuted, marginBottom: 6, lineHeight: 1.6 }}>
              <div>Decisión: <strong style={{ color: textPrimary }}>{searchDecision.action}</strong>{e.metadata?.totalResultados !== undefined ? ` · ${e.metadata.totalResultados} resultados` : ""}</div>
              {criterios && Object.keys(criterios).length > 0 && (
                <div>Criterios: {Object.entries(criterios).map(([k, v]) => `${k}=${JSON.stringify(v)}`).join(" · ")}</div>
              )}
              {expansion && (
                <div>Ampliación sugerida: {expansion.baseTown} → {expansion.suggestions.join(", ")}</div>
              )}
              {expansionResolution?.handled && (
                <div>
                  Respuesta del cliente a la ampliación: {expansionResolution.accepted ? "aceptada" : "rechazada"}
                  {expansionResolution.addedValues?.length ? ` · añadidas ${expansionResolution.addedValues.join(", ")}` : ""}
                </div>
              )}
            </div>
          )}
          {interestEvaluation && (
            <div style={{ fontSize: 11, color: textMuted, marginBottom: 6, lineHeight: 1.6 }}>
              <div>
                Interés: <strong style={{ color: textPrimary }}>{interestEvaluation.qualification}</strong>
                {interestEvaluation.score !== undefined ? ` · score ${interestEvaluation.score}` : ""}
                {interestEvaluation.next_action ? ` · acción ${interestEvaluation.next_action}` : ""}
              </div>
              {interestEvaluation.property_interest && (
                <div>Vivienda: {interestEvaluation.property_interest} · intención cliente: {interestEvaluation.cliente_intent}</div>
              )}
              {interestEvaluation.reason_codes?.length ? (
                <div>Razones: {interestEvaluation.reason_codes.join(" · ")}</div>
              ) : null}
            </div>
          )}
          {e.nombre && (
            <div style={{ fontSize: 11, color: textMuted }}>
              👤 {e.nombre}{e.telefono ? ` · 📱 ${e.telefono}` : ""}
            </div>
          )}
          {e.metadata && (
            <pre style={{
              fontSize: 10, color: textMuted, marginTop: 6,
              background: isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)",
              padding: "6px 10px", borderRadius: 6, overflow: "auto",
              maxHeight: 120, fontFamily: "monospace",
            }}>
              {JSON.stringify(e.metadata, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}

export default function Monitor() {
  const { theme } = useTheme();
  const isDark = theme.name === "dark";
  const bgPage = theme.colors.bgApp;
  const bgPanel = theme.colors.bgPanel;
  const border = theme.colors.border;
  const textPrimary = theme.colors.textPrimary;
  const textMuted = theme.colors.textMuted;

  const [eventos, setEventos] = useState([]);
  const [conectado, setConectado] = useState(false);
  const [pausado, setPausado] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState("todos");
  const pausadoRef = useRef(false);
  const bottomRef = useRef(null);
  const eventSourceRef = useRef(null);

  // Cargar historial inicial
  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API}/monitor/eventos`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(d => { if (d.ok) setEventos(d.data); })
      .catch(() => {});
  }, []);

  // SSE tiempo real
  useEffect(() => {
    const token = localStorage.getItem("token");
    const es = new EventSource(`${API}/monitor/stream?token=${token}`);
    eventSourceRef.current = es;

    es.addEventListener("evento", (e) => {
      if (pausadoRef.current) return;
      try {
        const evento = JSON.parse(e.data);
        setEventos(prev => [...prev, evento].slice(-500)); // máx 500
      } catch {
        // Ignorar eventos SSE malformados.
      }
    });

    es.onopen = () => setConectado(true);
    es.onerror = () => setConectado(false);

    return () => es.close();
  }, []);

  // Auto-scroll al último evento
  useEffect(() => {
    if (!pausado) bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [eventos, pausado]);

  const togglePausa = () => {
    pausadoRef.current = !pausadoRef.current;
    setPausado(p => !p);
  };

  const limpiar = () => setEventos([]);

  const eventosFiltrados = filtroTipo === "todos"
    ? eventos
    : eventos.filter(e => e.tipo === filtroTipo);

  return (
    <AppLayout>
      <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 57px)", background: bgPage }}>

        {/* Header */}
        <div style={{
          padding: "14px 24px", background: bgPanel, borderBottom: `1px solid ${border}`,
          display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: conectado ? "#22c55e" : "#ef4444", animation: conectado ? "pulse 2s infinite" : "none" }} />
            <span style={{ fontWeight: 700, fontSize: 16, color: textPrimary }}>Monitor de flujo</span>
            <span style={{ fontSize: 12, color: textMuted }}>{eventosFiltrados.length} eventos</span>
          </div>

          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {/* Filtro tipo */}
            <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} style={{
              fontSize: 12, padding: "4px 8px", borderRadius: 6, border: `1px solid ${border}`,
              background: bgPanel, color: textPrimary, cursor: "pointer",
            }}>
              <option value="todos">Todos los eventos</option>
              {Object.entries(TIPOS).map(([k, v]) => (
                <option key={k} value={k}>{v.icon} {v.label}</option>
              ))}
            </select>

            {/* Pausar */}
            <button onClick={togglePausa} style={{
              padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
              border: `1px solid ${border}`, background: pausado ? "rgba(245,158,11,0.15)" : "transparent",
              color: pausado ? "#f59e0b" : textMuted,
            }}>
              {pausado ? "▶ Reanudar" : "⏸ Pausar"}
            </button>

            {/* Limpiar */}
            <button onClick={limpiar} style={{
              padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
              border: `1px solid ${border}`, background: "transparent", color: textMuted,
            }}>
              🗑 Limpiar
            </button>
          </div>
        </div>

        {/* Lista eventos */}
        <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px" }}>
          {eventosFiltrados.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: 80, color: textMuted }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📡</div>
              <div style={{ fontSize: 14 }}>Esperando eventos...</div>
              <div style={{ fontSize: 12, marginTop: 6 }}>Los eventos aparecerán aquí en tiempo real</div>
            </div>
          ) : (
            eventosFiltrados.map(e => (
              <EventoItem key={e.id} e={e} isDark={isDark} border={border} textPrimary={textPrimary} textMuted={textMuted} />
            ))
          )}
          <div ref={bottomRef} />
        </div>

      </div>
    </AppLayout>
  );
}
